export default "__VITE_ASSET__AG9tykrv__"